<template>
  <div>
    <template v-if="routeMatchesComponent()">
      <div v-if="firstLoad" class="white-bg m3 p3">
        <div v-if="!ordersListing.length" class="p3 white-bg">
          <span class="h5n semi-bold">{{ getReferencelabel('NO_BOOKINGS_HISTORY') }}</span>
          <hr class="col-12 dark-grey mt3" />
        </div>
        <div v-for="(order, index) in ordersListing" v-else :key="index" class="white-bg mb3 border-none rounded">
          <div v-if="index !== 0" class="flex justify-center col-12 mb3" >
            <hr class="col-12 dark-grey" />
          </div>

          <div class="relative col-12 p2 border grey-border" style="border-width: 10px">
            <div class="flex flex-column col-12">
              <div class="flex col-12 justify-between pb2" style="min-height: 50px">
                <div class="flex flex-column">
                  <span class="h6n dark-grey">{{ getReferencelabel('DATE_OF_PURCHASE') }}: {{ order.purchaseDate }}</span>
                  <span v-if="getOrderContext(order.customerIresaId)" class="h5n bold dark-blue">U-Pool: {{ getOrderContext(order.customerIresaId) }}</span>
                </div>
              </div>
              <div class="flex items-center col-12 py2">
                <h3 class="h4n m0 bold dark-blue center items-center" style="flex-grow: 1">{{ genericOrderObject(order).productName }}</h3>
              </div>

              <p class="h6n pt2 m0 dark-grey flex items-end" style="min-height: 50px">{{ getReferencelabel('RESERVATION_NUMBER') }}: {{ order.bookingNumber }}</p>
            </div>
            <router-link :to="{ name: 'OrderBill', params: { uuid: order.bookingNumber } }" class="absolute right-0 pointer flex items-center justify-end" style="top: 50%; transform: translateY(-50%); width: 48px; height: 48px;">
              <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8.59 16.59L13.17 12L8.59 7.41L10 6L16 12L10 18L8.59 16.59Z" fill="currentColor" />
              </svg>
            </router-link>
          </div>
        </div>
        <div v-if="showMoreButton" class="flex flex-wrap justify-center">
          <ButtonV2 reference="SEE_MORE" rounded class="px4 py2 h6n" color="dark" :action="loadMoreOrders" style="width: 300px" />
        </div>
      </div>
    </template>
    <router-view v-else />
  </div>
</template>

<script>
import { onMounted, ref, computed, getCurrentInstance } from 'vue';
import { useStore } from 'vuex';
import { useRoute } from 'vue-router';
import ButtonV2 from '@/components/elements/ButtonV2';
import Breadcrumb from '@/components/common/Breadcrumb';
import { getReferencelabel, routeIsCurrentComponent } from '@/mixins/utils';

import { getOrders } from '@/mixins/requests';

export default {
  components: {
    Breadcrumb,
    ButtonV2,
  },
  setup() {
    const store = useStore();
    const route = useRoute();

    const routeMatchesComponent = () => routeIsCurrentComponent(route.name, getCurrentInstance());

    const firstLoad = ref(false);
    const start = ref(0);
    const limit = ref(3);
    const ordersCount = ref(0);
    const ordersListing = ref([]);
    const userIresaIds = ref(store.state.user.iresa_ids);

    // Total of fetched orders without filters
    const totalSyncOrderCount = ref(0);
    const showMoreButton = computed(() => ordersCount.value > totalSyncOrderCount.value);

    function genericOrderObject(data) {
      return {
        productName: data.mainProduct,
        description: data.mainProduct,
        date: `${data.startDate} - ${data.endDate}`,
        status: data.status,
      };
    }

    async function loadMoreOrders() {
      start.value += limit.value;
      await syncOrders();
    }

    async function syncOrders() {
      store.commit('setLoading', true);
      const { count, items } = await getOrders(
        start.value,
        limit.value
      );

      ordersCount.value = count;
      totalSyncOrderCount.value += items.length;

      ordersListing.value = [...(ordersListing.value || []), ...items.filter(o => o.status !== 'Option' && o.status !== 'Annulé')];

      store.commit('setLoading', false);
    }

    const getOrderContext = iresaId => {
      const context = store.state.user.iresa_ids.find(c => c.iresa_id === iresaId)?.context;

      if (!context) {
        return null;
      }
      const contextLabel = store.state.user.contexts.find(c => c.value === context).label;

      if (contextLabel === 'Vacances') {
        return 'UCPA Vacances';
      }

      return contextLabel.toUpperCase();
    };

    onMounted(async () => {
      await syncOrders();
      firstLoad.value = true;
    });

    return {
      firstLoad,
      ordersListing,
      showMoreButton,
      genericOrderObject,
      loadMoreOrders,
      syncOrders,
      getReferencelabel,
      routeMatchesComponent,
      getOrderContext,
    };
  },
};
</script>
